<template>
  <el-form ref="baseForm" :disabled="!canEdit" :model="storeInfo" :rules="rules" label-width="120px" class="el-form-flex">
    <el-row v-if="storeInfo && storeInfo.detail" :gutter="20">
      <el-col :sm="24" :md="12" :lg="10">
        <div class="el-form-content">
          <el-form-item label="经营类型" prop="workingGroup">
            <el-select v-model="storeInfo.detail.workingGroup" class="max-width" @change="onChange">
              <el-option :value="12" label="普通商户" />
            </el-select>
          </el-form-item>
          <el-form-item label="商户类型" prop="merchantType">
            <el-radio-group v-model="storeInfo.detail.merchantType" size="small" class="max-width" @input="onChange">
              <el-radio-button :label="1">企业商户</el-radio-button>
              <el-radio-button :label="2">个体工商户</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="推荐人邀请码" prop="inviteCode">
            <el-input v-model.trim="storeInfo.inviteCode" placeholder="请输入推荐人邀请码" class="max-width" @blur="onChange" />
            <span v-if="storeInfo.inviterName" class="pl-10">{{ storeInfo.inviterName }}</span>
          </el-form-item>
          <el-form-item label="商户全称" prop="shopName">
            <el-input v-model.trim="storeInfo.shopName" placeholder="请输入营业执照上的全称" @blur="onChange" />
          </el-form-item>
          <el-form-item label="商户简称" prop="shortName">
            <el-input v-model.trim="storeInfo.shortName" placeholder="将在支付完成页面向消费者展示" @blur="onChange" />
          </el-form-item>
          <el-form-item label="营业执照编号" prop="detail.licenceNo">
            <el-input v-model.trim="storeInfo.detail.licenceNo" placeholder="请输入统一社会信用代码" @blur="onChange" />
          </el-form-item>
          <el-form-item label="执照有效期类型">
            <el-radio-group v-model="storeInfo.detail.licenseDateType" class="max-width" @input="onChange">
              <el-radio-button :label="1">非长期</el-radio-button>
              <el-radio-button :label="2">长期</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="storeInfo.detail.licenseDateType === 1" label="营业执照有效期" prop="detail.licenseDate">
            <el-date-picker
              key="licenseDateType1"
              v-model="storeInfo.detail.licenseDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @blur="onChange"
            />
          </el-form-item>
          <el-form-item v-else label="营业执照有效期" prop="detail.licenseStart">
            <el-date-picker
              key="licenseDateType2"
              v-model="storeInfo.detail.licenseStart"
              type="date"
              placeholder="开始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="max-width"
              @blur="onChange"
            />
          </el-form-item>
          <el-form-item label="所在区域" prop="regionInfo">
            <el-cascader
              v-if="showRegion"
              ref="regionCascader"
              v-model="storeInfo.regionInfo"
              :props="{ value: 'regionCode', label: 'regionName' }"
              :options="regionOptions"
              placeholder="请选择所在区域"
              clearable
              style="width:100%"
              @change="regionChange"
            />
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model.trim="storeInfo.address" placeholder="请输入详细地址" @blur="onChange" />
          </el-form-item>
          <el-form-item label="积分抵扣" prop="discount">
            <el-input v-model="storeInfo.discount" type="number" min="0" max="30" placeholder="请输入优惠折扣" class="max-width" @blur="onChange">
              <span slot="suffix">%</span>
            </el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :sm="24" :md="12" :lg="{span: 10, offset: 4}">
        <div class="el-form-content">
          <el-form-item label="登录手机号" prop="mobile">
            <el-input v-model="storeInfo.mobile" type="number" :maxlength="11" placeholder="请输入11位手机号码" class="max-width" @blur="onChange" />
          </el-form-item>
          <el-form-item v-if="!disabled" label="登录密码" prop="password">
            <el-input v-model="storeInfo.password" show-password placeholder="请输入登录密码" class="max-width" @blur="onChange" />
          </el-form-item>
          <el-form-item v-if="disabled" label="平台商户编号">
            <el-input v-model="storeInfo.merchantId" disabled placeholder="平台商户编号" @blur="onChange" />
          </el-form-item>
          <el-form-item label="法人姓名" prop="detail.legalName">
            <el-input v-model="storeInfo.detail.legalName" placeholder="请输入法人姓名" @blur="onChange" />
          </el-form-item>
          <el-form-item label="法人身份证号码" prop="detail.legalIdCard">
            <el-input v-model="storeInfo.detail.legalIdCard" placeholder="请输入法人身份证号码" @blur="onChange" />
          </el-form-item>
          <el-form-item label="证件有效期类型">
            <el-radio-group v-model="storeInfo.detail.cardDateType" class="max-width" @input="onChange">
              <el-radio-button :label="1">非长期</el-radio-button>
              <el-radio-button :label="2">长期</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="storeInfo.detail.cardDateType === 1" label="法人证件有效期" prop="detail.cardDate">
            <el-date-picker
              key="cardDateType1"
              v-model="storeInfo.detail.cardDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @blur="onChange"
            />
          </el-form-item>
          <el-form-item v-else label="法人证件有效期" prop="detail.legalCardStart">
            <el-date-picker
              key="cardDateType2"
              v-model="storeInfo.detail.legalCardStart"
              type="date"
              placeholder="开始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              class="max-width"
              @blur="onChange"
            />
          </el-form-item>
          <el-form-item label="营业时间" prop="openHours">
            <el-time-picker v-model="storeInfo.openHours[0]" format="HH:mm" value-format="HH:mm" :editable="false" placeholder="开始时间" class="max-width" @blur="onChange" />
            <span class="ml-10 mr-10">至</span>
            <el-time-picker v-model="storeInfo.openHours[1]" format="HH:mm" value-format="HH:mm" :editable="false" placeholder="打烊时间" class="max-width" @blur="onChange" />
          </el-form-item>
          <el-form-item label="门店电话" prop="phone">
            <el-input v-model="storeInfo.phone" type="number" placeholder="请输入门店电话" class="max-width" @blur="onChange" />
          </el-form-item>
          <el-form-item label="特色介绍" prop="feature">
            <el-input v-model="storeInfo.feature" placeholder="请输入特色介绍" @blur="onChange" />
          </el-form-item>
          <el-form-item label="资质编号" prop="detail.qualification">
            <el-input v-model.trim="storeInfo.detail.qualification" placeholder="请输入资质编号，如：粤卫食证字[2007]第0307A123456" @blur="onChange" />
          </el-form-item>
          <el-form-item label="排序" prop="sortBy">
            <el-input v-model="storeInfo.sortBy" type="number" min="0" placeholder="请输入排列顺序" class="max-width" @blur="onChange" />
          </el-form-item>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'ShopBase',
  emits: ['input'],
  props: {
    isSupplier: Boolean,
    disabled: Boolean,
    canEdit: Boolean,
    value: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      storeInfo: {},
      showRegion: true,
      regionOptions: this.$store.getters.regionMap
    }
  },
  watch: {
    value: {
      deep: true,
      handler(newInfo) {
        this.storeInfo = { ...newInfo }
      }
    }
  },
  mounted() {
    this.storeInfo = { ...this.value }
  },
  methods: {
    regionChange(regionValue) {
      this.storeInfo = Object.assign({}, this.storeInfo, {
        regionCode: (regionValue && regionValue.length) ? regionValue.join(',') : '',
        regionName: (regionValue && regionValue.length) ? this.$refs.regionCascader.getCheckedNodes()[0].pathLabels.join('') : ''
      })
      this.$emit('input', this.storeInfo)
    },
    onChange() {
      this.$emit('input', this.storeInfo)
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject('校验失败')
          }
        })
      })
    },
    reset() {
      this.$refs.baseForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-group {
  display: inline-flex;
  align-items: center;
  .el-radio {
    flex: 1;
  }
}
.el-form-item {
  .max-width {
    max-width: 200px;
  }
  .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    max-width: 100%;
    width: 100%;
  }
}
</style>
